import { useEffect, useRef } from "react"
import { refreshTokensIfNeeded } from "@/api/service"
import { isTokenValid, getTokenFromStorage } from "@/helpers/jwt"

export const useTokenRefresh = () => {
  const intervalRef = useRef<number | null>(null)

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      const accessToken = getTokenFromStorage("accessToken")
      if (!accessToken) {
        return
      }

      if (!isTokenValid("accessToken")) {
        if (isTokenValid("refreshToken")) {
          await refreshTokensIfNeeded()
        }
      } else {
        await refreshTokensIfNeeded()
      }
    }

    checkAndRefreshToken()

    intervalRef.current = setInterval(checkAndRefreshToken, 5 * 60 * 1000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])
}
